export enum HomeSubscreen {
  None = 'none',
  Challenges = 'challenges',
  ChallengeSolved = 'challenge_solved',
  CustomChallenges = 'custom_challenges',
  Index = 'index',
  WhatIs = 'whatis',
}
